
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking/[slug]",
      function () {
        return require("private-next-pages/parking/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking/[slug]"])
      });
    }
  